module.exports = __webpack_public_path__ + "img/southern-union-old.d5d3016f.jpg";